module.exports = __webpack_public_path__ + "img/new_price_pc.9bd4a6cd.png";